export default __webpack_public_path__ + "static/shueyshing_og_image-a522c528a34f0217f34fb6b2ab609398.jpg";